/**
 * Tracks which files currently have an AiSummary view mounted (modal or right panel).
 * Used by the notifications system to skip the "summary ready" toast when the user
 * is already looking at the summary, which updates itself via websocket.
 */
const openViewCountByFileId = new Map<number, number>();

/** Registers a mounted AiSummary view for the given file. */
export function registerOpenAiSummaryView(fileId: number): void {
  openViewCountByFileId.set(fileId, (openViewCountByFileId.get(fileId) ?? 0) + 1);
}

/** Unregisters a mounted AiSummary view for the given file. */
export function unregisterOpenAiSummaryView(fileId: number): void {
  const count = openViewCountByFileId.get(fileId) ?? 0;
  if (count <= 1) {
    openViewCountByFileId.delete(fileId);
  } else {
    openViewCountByFileId.set(fileId, count - 1);
  }
}

/** Whether an AiSummary view is currently mounted for the given file. */
export function isAiSummaryViewOpenForFile(fileId: number): boolean {
  return (openViewCountByFileId.get(fileId) ?? 0) > 0;
}
